import { render, staticRenderFns } from "./smartTrade.vue?vue&type=template&id=0c1ef4fa&scoped=true"
import script from "./smartTrade.vue?vue&type=script&lang=js"
export * from "./smartTrade.vue?vue&type=script&lang=js"
import style0 from "./smartTrade.vue?vue&type=style&index=0&id=0c1ef4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ef4fa",
  null
  
)

export default component.exports